import cx from 'classnames'
import type { FieldRenderProps } from 'react-final-form'

import { isFieldHighlighted } from '@helpers'

import type { TextareaFieldProps } from '@components/ui/InputElements'
import { TextareaField } from '@components/ui/InputElements'

type RenderTextFieldProps = FieldRenderProps<Nullable<string>, HTMLTextAreaElement> &
  TextareaFieldProps & {
    highlighted?: boolean
    forcedError?: boolean // this is useful for triggering an error state for the field without the actual form field having an error (visibility purposes)
  }

export function RenderTextareaField({
  className,
  disabled = false,
  forcedError = false,
  highlighted = false,
  input: { name, onChange, onBlur, onFocus, value },
  label,
  meta: { dirtySinceLastSubmit, error, submitError, touched, modifiedSinceLastSubmit },
  required = false,
  ...rest
}: RenderTextFieldProps) {
  const displayedError = touched && (error || (!dirtySinceLastSubmit && !modifiedSinceLastSubmit && submitError))
  const hasError = Boolean(displayedError || forcedError)

  return (
    <TextareaField
      className={cx(className, { 'form-control-error': hasError })}
      disabled={disabled}
      error={hasError}
      helperText={displayedError}
      highlighted={isFieldHighlighted(highlighted, value)}
      id={name}
      label={label}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      required={required}
      value={value ?? ''}
      {...rest}
    />
  )
}
